// extracted by mini-css-extract-plugin
export default {"bid-history-cta":"g__bid-history-cta--vlpAs"};